import { Location } from 'vue-router';

export interface ContentsLocation {
  toContentsLocation: () => Location;
  toContentsDetailLocation: (params: { detailId: string }) => Location;
}

export const useContentsLocation = (): ContentsLocation => {
  const toContentsLocation = (): Location => {
    return {
      name: 'contents-custom',
    };
  };

  const toContentsDetailLocation = (params: { detailId: string }): Location => {
    return {
      name: 'contents-detail-custom',
      params,
    };
  };

  return {
    toContentsLocation,
    toContentsDetailLocation,
  };
};
